import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'confirmation-modal',
    template: require('./confirmation.modal.html')
})

export class ConfirmationModalComponent {
    @Input() title: string;
    @Input() body: string;

    constructor(public activeModal: NgbActiveModal) {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/modals/confirmation.modal.ts